module.exports = __webpack_public_path__ + "img/26_204.17275745.png";